import { render, staticRenderFns } from "./tickets-view.vue?vue&type=template&id=8034fe1c"
import script from "./tickets-view.vue?vue&type=script&lang=js"
export * from "./tickets-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports